<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper">
            <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                <img :src="`http://nrell.com/${item.picurl}`" alt="">
                <div class="text animated fadeInUp">
                    <p :style="aStyle(0)">{{item.title}}</p>
                    <p :style="aStyle(1)">{{item.description}}</p>
                </div>
                <!-- <div class="play" @click="playVideo">
                    <i class="iconfont icon-11"></i>
                    <span>{{$t('play')}}</span>
                </div> -->
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination">

        </div>
        <div class="video-full"   :class="{ showVideo }">
            <div class="video-content">
                <div class="video-close"
                     @click="pauseVideo">
                    <i class="el-icon-close"></i>
                </div>
                <video
                        id="videoPlay01"
                        controls="controls"
                        style="z-index: 3000">
                    <source
                            type="video/mp4;"
                            src="https://www.sansg.com/video/aomate.mp4"
                            data-src="https://www.sansg.com/video/aomate.mp4">

                    你的浏览器不支持
                    <code>video</code> 标签.
                </video>
            </div>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getPicUrl} from '../util/lang'
    import '../common/jquery-1.11.3.min'
    export default {
        name: "banner",
        data(){
            return{
                showVideo:false,
                bList:[],
                swiperOptiona:{
                    pagination: {
                        el: ".banner .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                    loop: true,
                    effect: 'fade',
                    init: false,
                    autoplay:{
                        disableOnInteraction: false,
                        delay: 3000
                    },
                    on:{
                        slideChangeTransitionEnd: () => {
                            this.$nextTick(() => {
                                let swiper = this.$refs.mySwipers.swiper;
                                let active = swiper.realIndex;
                                let previousIndex = swiper.previousIndex;
                                let bullets = swiper.pagination.bullets;
                                let bulletsArray = Array.from(bullets);
                                for (let i = 0; i < bulletsArray.length; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("0%")
                                }
                                for (let i = 0; i < active; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("100%")
                                }
                                $('.banner .swiper-pagination .swiper-pagination-bullet').eq(active).children('i').stop().animate({width: '100%'}, 3000, "linear")

                            });
                        }
                    }
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
        props:['list'],
        mounted(){
            // this.$nextTick(()=>{
            //     if(this.$i18n.locale==='en'){
            //         this.getList('12')
            //     }else{
            //         this.getList('8')
            //     }
            // })
        },
        watch:{
            list(val){
                this.$refs.mySwipers.swiper.init()
            }
        },
        methods:{
            pauseVideo(){
                const audioPlayer = window.document.getElementById('videoPlay01');
                audioPlayer.pause();
                this.showVideo=false
            },
            playVideo(){
                const audioPlayer = window.document.getElementById('videoPlay01');
                audioPlayer.load();
                audioPlayer.play();
                this.showVideo=true
                console.log("aa")
            },
            aStyle(n){
                return {animationDelay:n*0.5+0.5+'s'}
            },
            // getList(id){
            //     const url = `${getPicUrl( this.$i18n.locale,'首页banner',id)}`
            //     this.$axios.get(url).then(res => {
            //         this.bList=res.data
            //         setTimeout(()=>{
            //             this.$refs.mySwipers.swiper.init()
            //         },100)

            //     })
            // }
        }
    }
</script>

<style lang="scss" scoped>
.banner{
    width:100%;
    height:100vh;
    position: relative;
    .swiper{
        height:100%;
        .item{
            position: relative;
            overflow: hidden;
            img{
                width:100%;
                height:100%;
                object-fit: cover;
                display: block;
                z-index: 1;
                cursor: pointer;
            }
            .text{
                z-index: 10;
                position: absolute;
                left: 10%;
                top:30%;
                width:25%;
                text-transform: uppercase;
                font-size: 30px;
                height:200px;
                overflow: hidden;
                p:nth-child(1){
                    font-weight: bolder;
                    color:white;
                    line-height:50px;
                    font-family: Calibri;
                    border-top: 1px solid rgba(255,255,255,.2);
                    padding-top: 30px;
                    position: relative;
                   transform: translateY(200px);
                    transition: all 600ms;
                }
                p:nth-child(1)::before{
                    position: absolute;
                    content:'';
                    display: inline-block;
                    top:-1px;
                    left:0;
                    width:30%;
                    background-color: rgba(255,255,255,.6);
                    height:1px;
                }
                p:nth-child(2){
                   font-family: light;
                    color:white;
                    margin-top: 20px;
                    font-size:30px;
                    transform: translateY(200px);
                    transition: all 600ms;
                }
            }
            .play{
                z-index: 1000;
                position: absolute;
                left: 10%;
                bottom:40%;
                width:25%;
                text-transform: uppercase;
                cursor: pointer;
                i{
                    font-size: 30px;
                    color:rgba(255,255,255,.4);
                    vertical-align: middle;
                    transition: all 2s;
                }
                span{
                    color:rgba(255,255,255,.8);
                    font-size: 14px;
                    transition: all 2s;
                    padding-left: 10px;
                }
            }
            .play:hover{
                i,span{
                    color:white;
                }
            }
        }
        .swiper-slide-active{
            .text{
               p:nth-child(1){
                   transform: translateY(0);
               }
                p:nth-child(2){
                    transform: translateY(0);
                }
            }
        }
    }
    @media screen and (min-width:2200px){
  .swiper{
      .item{
          .text{
            //   height:180px;
              width:22%;
              p:nth-child(2){
                //   width:80%;
              }
          }
      }
  }
    }
    @media screen and (max-width: 1440px){
        .swiper{
            .item{
                .text{
                    height:300px;
                    width:50%;
                    font-size: 25px;
                    p:nth-child(2){
                        width:50%;
                        font-size: 25px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 450px){
        .swiper{
            .item{
                .text{
                    width:90%;
                    font-size: 20px;
                    p:nth-child(2){
                        width:100%;
                        font-size: 18px;
                        margin-top: 0;
                    }
                }
                .play{
                    width:80%;
                    bottom:20%;
                }
            }
        }
    }
}
</style>
<style scoped>
    .banner .swiper-pagination {
        left: 10%;
        bottom:35%;
        width:40%;
        text-align: left;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 65px;
        height: 4px;
        border: 1px solid #fff;
        border-radius: 0;
        opacity: 0.6;
        margin: 0 5px;
        background-color: transparent;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background-color: #fff;
    }
    @media screen and (max-width:450px){
        .banner .swiper-pagination{
            width:100%;
            bottom:5%;
            display: flex;
            flex-direction: row;
        }
    }
    video{
        border: none;
    }
    video:focus{
        outline: none;
    }
    .video-full {
        display: none;
    }
    .video-full.showVideo {
        display: block;
        position: fixed;
        top: 89px;
        left: 0;
        width: 100%;
        height: 93vh;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 10000;
    }
    .video-bg {
    }
    .video-close {
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 3200;
    }
    .video-close i {
        transition: opacity 0.4s ease-in-out;
        font-size: 20px;
        color: #fff;
    }
    .video-content {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3000;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
    .video-content video {
        width: 100%;
        height: 100%;
    }
</style>
